import EventEmitter from 'events';

export const sdkEventBus = new EventEmitter();

export const SDK_PUBLISH_DOCUMENT = 'sdkPublishDocument';
// 发布结束 成功或者失败都会触发
export const SDK_PUBLISH_DOCUMENT_END = 'sdkPublishDocumentEnd';

export const SDK_RTE_NOTIFY = 'sdkRteNotify';

export default {
    emitRteNotify: (data: any) => {
        sdkEventBus.emit(SDK_RTE_NOTIFY, data);
    },
    onRteNotify: (callback: (data: any) => void) => {
        sdkEventBus.on(SDK_RTE_NOTIFY, callback);
    },
    offRteNotify: () => {
        sdkEventBus.removeAllListeners(SDK_RTE_NOTIFY);
    },
    emitPublish: () => {
        sdkEventBus.emit(SDK_PUBLISH_DOCUMENT);
    },
    onPublish: (callback: (data: any) => void) => {
        sdkEventBus.on(SDK_PUBLISH_DOCUMENT, callback);
    },
    offPublish: () => {
        sdkEventBus.removeAllListeners(SDK_PUBLISH_DOCUMENT);
    },
    onPublishEnd: (callback: (data: any) => void) => {
        sdkEventBus.on(SDK_PUBLISH_DOCUMENT_END, callback);
    },
    emitPublishEnd: (data: any) => {
        sdkEventBus.emit(SDK_PUBLISH_DOCUMENT_END, data);
    },
    offPublishEnd: () => {
        sdkEventBus.removeAllListeners(SDK_PUBLISH_DOCUMENT_END);
    }
}